// vimeo hero functions

var hero_video =  document.getElementById('hero-video');

if (typeof(hero_video) != 'undefined' && hero_video != null) {
  var videoPlayer = new Vimeo.Player('hero-video');

  videoPlayer.on('play', function() {
    document.querySelector('.hero__background__video').classList.add('hide-mask');
  });

  videoPlayer.on('timeupdate', function(data) {

    if (data.percent >= 0.01) {
      document.querySelector('.hero__background__video').classList.add('hide-mask');
    }

    // if (data.percent >= 0.95) {
    //   document.querySelector('.hero__background__video').classList.remove('hide-mask');
    // }
  });
}
